<template>
  <div class="bs_">
    <div class="head">
      <img
        class="H_img"
        src="../../../assets/image/nsale/pcenter/head.png"
        alt="head"
      />
      <div>冯浩航</div>
      <div>18310427778</div>
    </div>

    <div class="list">
      <div class="L_left">
        <img
          class="L_img"
          src="../../../assets/image/nsale/pcenter/icon1.png"
          alt="img"
        />
        <span>认证信息</span>
      </div>
      <span
        ><span class="list_txt">未认证</span>
        <span class="arrow_r"></span>
      </span>
    </div>

    <div class="list">
      <div class="L_left">
        <img
          class="L_img"
          src="../../../assets/image/nsale/pcenter/icon3.png"
          alt="img"
        />
        <span>性别</span>
      </div>
      <span>
        <div
          class="sex_"
          :class="[gender == 'M' ? 'active_' : '']"
          @click="changeSex('M')"
        >
          男
        </div>
        <div
          class="sex_"
          :class="[gender == 'F' ? 'active_' : '']"
          @click="changeSex('F')"
        >
          女
        </div>
      </span>
    </div>

    <div class="list">
      <div class="L_left">
        <img
          class="L_img"
          src="../../../assets/image/nsale/pcenter/icon2.png"
          alt="img"
        />
        <span>手机号码</span>
      </div>
      <span>
        <span class="arrow_r"></span>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      gender: "M"
    };
  },
  methods: {
    changeSex(val) {
      this.gender = val;
    }
  }
};
</script>

<style lang="scss" scoped>
.bs_ {
  font-size: 14px;
  color: rgba(51, 51, 51, 1);
  .head {
    padding-top: 96px;
    margin-bottom: 60px;
    .H_img {
      width: auto;
      height: 69px;
    }
    div {
      &:nth-of-type(1) {
        margin: 10px 0;
        font-size: 16px;
        font-weight: bold;
      }
    }
  }

  .list {
    width: 88%;
    margin: 0 auto;
    background-color: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 54px;
    .L_left {
      display: flex;
      font-size: 15px;
      align-items: center;
      color: rgba(51, 51, 51, 1);
      .L_img {
        height: 25px;
        width: auto;
      }
    }
    .right_1 {
      height: 11px;
      width: auto;
      margin-left: 5px;
    }
    span {
      .sex_ {
        width: 50px;
        height: 25px;
        border: 1px solid rgba(153, 153, 153, 1);
        border-radius: 13px;
        font-size: 15px;
        color: rgba(153, 153, 153, 1);
        line-height: 25px;
        margin: 0 4px;
      }
      &:first-child {
        font-weight: bold;
        font-size: 15px;
        color: #333;
      }
      &:last-child {
        font-size: 15px;
        display: flex;
        align-items: center;
      }
      .list_txt {
        font-weight: normal;
        font-size: 15px;
        color: rgba(255, 74, 53, 1);
      }
      .list_txt1 {
        font-size: 12px;
        font-weight: normal;
        color: rgba(153, 153, 153, 1);
      }
      .arrow_r {
        position: relative;
        height: 44px;
        width: 20px;
        margin-left: 10px;
        &::after {
          position: absolute;
          top: 18px;
          right: 10px;
          display: block;
          content: "";
          width: 8px;
          height: 8px;
          border-top: 2px solid #999999;
          border-right: 2px solid #999999;
          transform: rotateZ(45deg);
        }
      }
    }
  }

  .active_ {
    background: rgba(255, 74, 53, 1);
    color: #fff !important;
    border: solid 1px rgba(255, 74, 53, 1) !important;
  }
}
</style>
